import { H1, H2, P } from "design_lib";
export default function Lead() {
  return (
    <div>
      <P>
        Be a visionary leader. Set the strategic direction with clarity and purpose, empowering your
        team to carry out that vision. A strategic leader makes bold, long-term decisions that shape
        the future of the company but remains flexible enough to adapt when necessary. Lead by
        example—your strategic thinking should be reflected in both your daily actions and big
        decisions. Inspire your team to align with the vision, ensuring everyone understands their
        role in the company’s success. Foster accountability at all levels, ensuring that every
        decision supports the broader strategic objectives. True strategic leadership guides the
        organization toward sustainable success, balancing immediate goals with long-term growth.
      </P>
      <P className="text-center">
        <i>
          “A leader is one who knows the way, goes the way, and shows the way.” – John C. Maxwell
        </i>
      </P>
      <H1>Examples:</H1>
      <H2>Herb Kelleher – Southwest Airlines: Visionary Leadership and Strategic Execution</H2>
      <P>
        Herb Kelleher’s leadership at Southwest Airlines was a model of visionary thinking and
        strategic execution. He set a clear strategic direction by focusing on low-cost,
        point-to-point air travel, fundamentally changing the airline industry. Kelleher’s
        leadership was characterized by making bold decisions, such as maintaining low fares while
        building a unique company culture based on respect and humor. He inspired his team to
        deliver on the company’s vision, creating an empowered workforce that helped Southwest
        maintain its competitive edge. By staying true to the company's core values and adjusting to
        market shifts, Kelleher led Southwest to unparalleled success.
      </P>
      <H2>Indra Nooyi – PepsiCo: Strategic Foresight and Adaptability</H2>
      <P>
        Indra Nooyi’s leadership at PepsiCo demonstrated the power of strategic foresight. She set a
        long-term vision to shift PepsiCo’s portfolio towards healthier products while retaining the
        strength of its core brands. Nooyi empowered her team to align with this vision, ensuring
        that PepsiCo adapted to consumer trends without compromising its foundational strengths. By
        balancing bold decisions with adaptability, Nooyi steered the company toward sustainable
        growth, positioning it for continued success in the evolving food and beverage market.
      </P>
      <H2>Satya Nadella – Microsoft: Refocusing on Cloud Computing and AI</H2>
      <P>
        Under Satya Nadella’s leadership, Microsoft refocused on cloud computing and artificial
        intelligence, charting a new strategic course for the company. Nadella’s strategic thinking
        was reflected in both his daily actions and major decisions, as he emphasized innovation and
        collaboration across the company. He empowered his team to execute with clarity, ensuring
        that every decision aligned with Microsoft’s broader vision. Nadella’s ability to adapt to
        changing market conditions while keeping a sharp focus on long-term goals has been key to
        Microsoft’s resurgence as a leader in the tech industry.
      </P>
    </div>
  );
}
